import React, { FC } from 'react';
import Navigation from 'evcharging/containers/layout/Navigation';
import Page from 'evcharging/components/Page';
import { createGetServerSideProps, StaticPageProps } from 'evcharging/app';
import Footer from 'evcharging/containers/layout/Footer';
import { I18nPage } from 'i18n/types/pages.enum';
import { getShopProduct, getShopProducts } from 'evcharging/services/cmsClient';
import ProductHeader from 'containers/shop/product/ProductHeader';
import { ShopProduct } from 'evcharging/services/types';
import SimilarProducts from 'containers/shop/product/SimilarProducts';
import New404 from 'pages/404';

interface ProductPageProps extends StaticPageProps {
  product: ShopProduct,
  similarProducts: ShopProduct[],
}

const category = 'thermostats';
const baseUrl = '/services/thermostat';

const ProductPage: FC<ProductPageProps> = (props) => {
  const { product, similarProducts } = props;

  if (!product) {
    return <New404 />;
  }

  return (
    <Page
      locales={['en']}
      title={product.name}
      description={product.name}
    >
      <Navigation hideSubNav />
      <ProductHeader baseUrl={baseUrl} product={product} />
      <SimilarProducts baseUrl={baseUrl} products={similarProducts.slice(0, 3)} />
      <Footer />
    </Page>
  );
};

export const getServerSideProps = createGetServerSideProps(undefined, async (context, locale) => {
    const { params } = context;
    const { product: link } = params;

    const product = await getShopProduct(category, String(link));
    const similarProducts = (await getShopProducts(category))
      .filter((item) => item.link !== product?.link);

    return {
      product,
      similarProducts,
    };
  },
  [I18nPage.AboutUs, I18nPage.Home]
);

export default ProductPage;
